import { useContext } from 'react';

import { ArticleContext } from '../Article.context';

export const StyledButton = (props: StyledButtonProps) => {
    const {
        id,
        text_lang,
        text,
        align,
        style,
        size,
        width,
        link,
        font_size,
        resource,
        pageid,
        pagetarget,
    } = props;
    const { lang } = useContext(ArticleContext);
    let content: any = text;
    if (lang && text_lang?.[lang]) {
        content = text_lang[lang];
    }
    return (
        <Button
            id={id}
            align={align}
            width={width}
            resource={resource}
            pageId={pageid}
            pageTarget={pagetarget}
            size={size}
            link={link}
            fontSize={`${font_size}`}
            StyleID={style}
            text={content}
            textTransform={props.case}
        />
    );
};

interface StyledButtonProps {
    id: string;
    text_lang: string;
    text: any;
    align: string;
    style: string;
    size: string;
    width: any;
    case: string;
    link: string;
    resource: string;
    pagetarget: string;
    pageid: string;
    externallinktarget: string;
    font_size: any;
}

export const Button = (props: ButtonProps) => {
    const {
        id = '',
        align = 'center',
        size = 'medium',
        link = '',
        text = '',
        StyleID = 'none',
        resource,
        pageId,
        pageTarget,
    } = props;
    const { onLightboxTargetClick, onEventSend } = useContext(ArticleContext);
    const containerStyle: any = {
        display: 'flex',
        width: '100%',
    };
    const componentStyle: any = {};

    let onClick = () => {};

    const attr: any = {};

    switch (resource) {
        case 'url':
            if (link) {
                onClick = () => {
                    onEventSend({
                        event: 'external',
                        data: {
                            url: link,
                            componentId: id,
                            componentType: 'button',
                        },
                    });
                    window.open(link, '_blank');
                };
            }
            break;
        case 'page':
            if (pageId && pageTarget) {
                onClick = () => {
                    onLightboxTargetClick({
                        id: pageId,
                        resource,
                        target: pageTarget,
                    });
                };
            }
            break;
        default:
            attr['disabled'] = true;
            break;
    }

    // Alignment
    switch (align) {
        case 'left':
            containerStyle.justifyContent = 'flex-start';
            break;
        case 'right':
            containerStyle.justifyContent = 'flex-end';
            break;
        default:
            containerStyle.justifyContent = 'center';
    }

    // Size
    switch (size) {
        case 'xsmall':
            componentStyle.padding = '2px 5px';
            break;
        case 'small':
            componentStyle.padding = `5px 10px`;
            break;
        case 'medium':
            componentStyle.padding = `8px 18px`;
            break;
        case 'large':
            componentStyle.padding = `12px 30px`;
            break;
        case 'xlarge':
            componentStyle.padding = `14px 40px`;
            break;
    }

    return (
        <div id={id} style={containerStyle}>
            <button
                {...attr}
                className={StyleID}
                style={componentStyle}
                onClick={onClick}
            >
                {text}
            </button>
        </div>
    );
};

interface ButtonProps {
    id: string;
    width: any;
    align: string;
    size: string;
    text: any;
    link: string;
    StyleID: string;
    fontSize: any;
    textTransform: string;
    resource: string;
    pageId: string;
    pageTarget: string;
}
